import React from "react";
import {LogoContainer} from "./common";
import {LOCALE} from "modules/constants";
import styled from "styled-components";
import cflLogo from "assets/images/cfl-question-logo.png";
import cflLogoFr from "assets/images/cfl-question-fr-logo.png";

const Logo = styled.img`
	max-width: 100%;
	max-height: 80px;
	height: auto;
`;

export const QuestionLogo: React.FC = () => {
	const logo = LOCALE === "en" ? cflLogo : cflLogoFr;

	return (
		<LogoContainer>
			<Logo src={logo} />
		</LogoContainer>
	);
};
